export enum Locale {
    DE = 'de',
    EN = 'en',
}
